import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Router from "./router/index";
import {
  ChakraProvider,
  extendTheme,
  defineStyleConfig,
} from "@chakra-ui/react";
import { UsersContextProvider } from "./Components/Context/UsersContext";

const Heading = defineStyleConfig({
  baseStyle: {},
  sizes: {
    sm: {
      fontSize: "1.1rem",
    },
    md: {
      fontSize: "1.3rem",
    },
  },
  variants: {
    h2: {
      as: "h2",
      size: "sm",
      fontSize: "1.1rem",
      pb: "1.5rem",
      textTransform: "uppercase",
    },
    h1: {
      as: "h1",
      fontSize: "1.5rem",
      size: "md",
    },
  },
});

const Button = defineStyleConfig({
  baseStyle: { flexShrink: 0 },
});

const theme = extendTheme({
  components: {
    Heading,
    Button,
  },
  styles: {
    global: {
      "html, body": {
        background: "#EBEBEB",
      },
      "td, tr": {
        padding: "0.25rem 0.75rem !important",
      },
      th: {
        padding: "0.75rem 0.75rem !important",
      },
      td: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "11rem",
      },
    },
  },
  colors: {
    menu: {
      100: "#FFFFFF",
      200: "#edf2f7",
      600: "#A0AEC0",
      700: "#909EA6",
      800: "#2A4054",
      900: "#0a0a11",
    },
    text: {
      100: "#FFFFFF",
      300: "#BDC2BF",
      400: "#989C94",
      500: "#5E5D5C",
      900: "#000000",
    },
  },
  breakpoints: {
    sm: "768px",
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ChakraProvider theme={theme}>
    <UsersContextProvider>
      <Router />
    </UsersContextProvider>
  </ChakraProvider>
);
